// extracted by mini-css-extract-plugin
export default {"root":"GG7fxn","overlay":"gcJgaw","mobile":"So6QC6","lastStep":"mIU02V"};